import { createAsyncThunk } from '@reduxjs/toolkit';

import { BasicInfoHttpGetService } from 'Feature/Common/Common/Services/BasicInfoHttpService';
import IGetActiveProvincesQuery from 'Feature/Common/Common/Types/Queries/IGetActiveProvincesQuery';
import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

export const getActiveProvinces = createAsyncThunk(
  'Province/getActiveProvinces',
  async (query?: IGetActiveProvincesQuery) => {
    return await BasicInfoHttpGetService({
      url: `${_apiPathManagerConfig?.BasicInfo.Province.GetActiveProvinces}`,
      params: query,
    });
  }
);
